import React from 'react';
import { Smile } from 'lucide-react';
import { Section } from './Section';
import { useLanguage } from './LanguageContext';
export function KidsSection() {
  const {
    t
  } = useLanguage();
  return <Section className="bg-barber-dark border-y border-barber-lightGray" data-id="element-252">
      <div className="max-w-4xl mx-auto flex flex-col md:flex-row gap-12 items-center" data-id="element-253">
        <div className="w-full md:w-1/3 flex justify-center" data-id="element-254">
          <div className="w-48 h-48 md:w-64 md:h-64 rounded-full border-4 border-barber-gold/30 flex items-center justify-center bg-barber-gray relative" data-id="element-255">
            <div className="absolute inset-0 rounded-full bg-barber-gold/5" data-id="element-256"></div>
            <Smile className="w-24 h-24 text-barber-gold relative z-10" strokeWidth={1.5} data-id="element-257" />
          </div>
        </div>
        <div className="w-full md:w-2/3 space-y-6 text-lg md:text-xl text-barber-muted" data-id="element-258">
          <h2 className="font-heading text-4xl md:text-5xl font-bold text-barber-text uppercase mb-6" data-id="element-259">
            {t('kids.heading1')}{' '}
            <span className="text-barber-gold" data-id="element-260">{t('kids.heading2')}</span>
          </h2>
          <p className="text-barber-text font-bold text-2xl" data-id="element-261">{t('kids.q')}</p>
          <p data-id="element-262">{t('kids.line1')}</p>
          <p data-id="element-263">{t('kids.line2')}</p>
          <div className="bg-barber-black p-6 border-l-4 border-barber-gold my-8" data-id="element-264">
            <p className="text-barber-text font-medium" data-id="element-265">{t('kids.box')}</p>
          </div>
          <p className="font-heading text-2xl text-barber-gold italic" data-id="element-266">
            {t('kids.quote')}
          </p>
        </div>
      </div>
    </Section>;
}